import { useRef, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import API_URL from "../../../const";
import Toast from "../../../Components/Toast/Toast";
import Spinner from "../../../Components/Spinner/Spinner";
import ToastError from "../../../Components/Toast/ToastError";

function DetailPage({ empresaData }) {
  const scrollRef = useRef(null);
  const [showLeft, setShowLeft] = useState(false);
  const [showRight, setShowRight] = useState(true);
  const navigate = useNavigate();

  // TODOS LOS HOOKS DEBEN IR AL INICIO, ANTES DE CUALQUIER RETURN
  const [isOwner, setIsOwner] = useState(false);
  const [empresas, setEmpresas] = useState(empresaData);
  const [image, setImage] = useState(empresaData);
  const [comentarios, setcomentarios] = useState("");
  const [review, setReview] = useState({
    autor: "",
    descripcion: "",
    idEmpresa: "",
  });

  const [error, setError] = useState(null);
  const [IsOpenSpinner, setIsOpenSpinner] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [showToastError, setShowToastError] = useState(false);
  const [msg, setMsg] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [openModalPerson, setOpenModalPerson] = useState(false);
  const [person, setPerson] = useState(false);
  const [active, setActive] = useState("aboutus");
  const [userData, setUserData] = useState("");

  const [formData, setFormData] = useState({
    id_empresa_fk: null,
    imagen_url: null,
  });
  const [formDataPerson, setFormDataPerson] = useState({
    idEmpresa: null,
    nombre: null,
    apellidoMaterno: null,
    apellidoPaterno: null,
    email: null,
    cargo: null,
    numero: null,
    empresa: null,
    imagen: null,
  });

  const [searchTerm, setSearchTerm] = useState("");
  const [resultados, setResultados] = useState([]);
  const [save, setSave] = useState(false);
  const [Id, setId] = useState("");

  // Variables que no necesitan ser estado
  const id_empresasFk = localStorage.getItem("id_empresasFk");
  const token = localStorage.getItem("token");
  const nombreUsuario = localStorage.getItem("nombre");

  const handleScrollCheck = () => {
    const container = scrollRef.current;
    if (!container) return;

    setShowLeft(container.scrollLeft > 0);
    setShowRight(
      container.scrollLeft + container.offsetWidth < container.scrollWidth,
    );
  };

  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    container.scrollLeft = 0;
    handleScrollCheck();
    container.addEventListener("scroll", handleScrollCheck);

    return () => {
      container.removeEventListener("scroll", handleScrollCheck);
    };
  }, []);

  useEffect(() => {
    if (
      id_empresasFk == null ||
      id_empresasFk == undefined ||
      id_empresasFk == ""
    ) {
      navigate("/login");
    } else {
      // Validar que empresaData existe y tiene al menos un elemento
      if (empresaData && Array.isArray(empresaData) && empresaData.length > 0) {
        setEmpresas(empresaData);
        // Validar que empresas[0] existe antes de acceder a sus propiedades
        if (empresaData[0] && empresaData[0].id_empresa) {
          if (parseInt(id_empresasFk) === parseInt(empresaData[0].id_empresa)) {
            setIsOwner(true);
          }
        }
      }
    }
  }, [empresaData, id_empresasFk, navigate]);

  // Validación mejorada de empresaData - DESPUÉS DE TODOS LOS HOOKS
  if (!empresaData || !Array.isArray(empresaData) || empresaData.length === 0) {
    return (
      <div className="w-full h-screen flex items-center justify-center">
        <div className="text-center">
          <i className="bx bx-error-circle text-6xl text-gray-400"></i>
          <p className="mt-4 text-gray-600">
            No se pudo cargar la información de la empresa
          </p>
          <button
            onClick={() => navigate("/catalogo")}
            className="mt-4 px-6 py-2 bg-blue-800 text-white rounded-lg hover:bg-blue-900"
          >
            Volver al catálogo
          </button>
        </div>
      </div>
    );
  }
  const handleChangePerson = (e) => {
    const { name, value } = e.target;
    setFormDataPerson((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setReview((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  const handleLogout = () => {
    localStorage.removeItem("nombre");
    localStorage.removeItem("idRol_fk");
    navigate("/");
  };
  const handleStatus = async (e) => {
    e.preventDefault();

    const formDataToSend = {
      nombre: "Primer Contacto con" + empresas[0].nombre,
      descripcion: "Creacion de la primera instancia de contacto",
      idempresa1: parseInt(id_empresasFk),
      idempresa2: empresas[0].id_empresa,
      typeConexion: 2,
    };

    try {
      const response = await fetch(`${API_URL}insertMatch.php`, {
        method: "POST",
        body: JSON.stringify(formDataToSend),
      });
      const data = await response.json();

      if (response.ok) {
        // Handle success
        window.open(empresas[0].whatsapp, "_blank");
      } else {
        // Handle error
        console.error("Error al registrar el newsletter:", data.error);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
    }
  };

  const getImagenEmpresa = () => {
    // Validar que empresas tenga datos
    if (!empresas || !empresas[0] || !empresas[0].id_empresa) {
      console.warn("No hay datos de empresa para cargar imágenes");
      return;
    }

    fetch(`${API_URL}getImagesDetail.php?id_empresa=${empresas[0].id_empresa}`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
        }
        return response.text();
      })
      .then((text) => {
        const startIndex = text.indexOf("[{");
        const endIndex = text.lastIndexOf("}]") + 2;
        let jsonResponse = text;

        if (startIndex !== -1 && endIndex > startIndex) {
          jsonResponse = text.substring(startIndex, endIndex);
        }

        try {
          const responseData = JSON.parse(jsonResponse);

          if (Array.isArray(responseData)) {
            setImage(responseData);
          } else {
            console.warn("Respuesta de imágenes no es un array");
            setImage([]);
          }
        } catch (error) {
          console.error("Error al analizar JSON de imágenes:", error);
          setImage([]);
        }
      })
      .catch((error) => {
        console.error("Error al obtener imágenes:", error);
        setImage([]);
      });
  };
  const getReviewsEmpresa = () => {
    // Validar que empresas tenga datos
    if (!empresas || !empresas[0] || !empresas[0].id_empresa) {
      console.warn("No hay datos de empresa para cargar reseñas");
      return;
    }

    fetch(
      `${API_URL}getReviewsEnterprice.php?id_empresa=${empresas[0].id_empresa}`,
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
        }
        return response.text();
      })
      .then((text) => {
        const startIndex = text.indexOf("[{");
        const endIndex = text.lastIndexOf("}]") + 2;
        let jsonResponse = text;

        if (startIndex !== -1 && endIndex > startIndex) {
          jsonResponse = text.substring(startIndex, endIndex);
        }

        try {
          const responseData = JSON.parse(jsonResponse);

          if (Array.isArray(responseData)) {
            setcomentarios(responseData);
          } else {
            console.warn("Respuesta de reseñas no es un array");
            setcomentarios([]);
          }
        } catch (error) {
          console.error("Error al analizar JSON de reseñas:", error);
          setcomentarios([]);
        }
      })
      .catch((error) => {
        console.error("Error al obtener reseñas:", error);
        setcomentarios([]);
      });
  };
  const insertReview = async (e) => {
    e.preventDefault();

    const reviews = {
      autor: nombreUsuario,
      idEmpresa: empresas[0].id_empresa,
      descripcion: review.descripcion,
    };

    setIsOpenSpinner(true);
    try {
      const response = await fetch(`${API_URL}insertReview.php`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: new URLSearchParams({ ...reviews }),
      });
      const text = await response.text();
      const startIndex = text.indexOf("[{");
      const jsonResponse =
        startIndex !== -1 ? text.substring(startIndex) : text;
      try {
        const responseData = JSON.parse(jsonResponse);
        if (response.ok) {
          setIsOpenSpinner(false);

          setShowToast(true);
          setReview({
            autor: "",
            descripcion: "",
            idEmpresa: "",
          });
          getReviewsEmpresa();

          setTimeout(() => {
            setShowToast(false);
          }, 5000);
        } else {
          console.error("Error del servidor:", response.statusText);
          setError(response.statusText || "Error desconocido");
          setIsOpenSpinner(false);
        }
      } catch (error) {
        console.error("Error al analizar JSON:", error);
        setError("Error de formato en la respuesta del servidor");
        setIsOpenSpinner(false);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      setError("Error de red: " + error.message);
    }
  };
  const deleteImageDetail = (id) => {
    fetch(`${API_URL}deleteImageDetail.php?id=${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => {
        if (response.ok) {
          getImagenEmpresa();
        } else {
          console.error("Error al eliminar el boletín");
        }
      })
      .catch((error) => console.error("Error de red:", error));
  };
  const openModals = () => {
    setOpenModal(true);
  };
  const handleSubmit = async (e) => {
    setOpenModal(false);
    setFormData({
      id_empresa_fk: null,
      imagen_url: null, // Changed to null to hold the file object
    });
    e.preventDefault();
    setIsOpenSpinner(true);

    const formDataToSend = new FormData();
    formDataToSend.append("id_empresa_fk", empresas[0].id_empresa);
    formDataToSend.append("imagen_url", formData.imagen_url);
    try {
      const response = await fetch(`${API_URL}insertImageDetail.php`, {
        method: "POST",
        body: formDataToSend,
      });
      const data = await response.json();

      if (response.ok) {
        setIsOpenSpinner(false);
        setShowToast(true);

        setTimeout(() => {
          setShowToast(false);
        }, 5000);
        // Handle success
      } else {
        // Handle error
        console.error("Error al registrar el newsletter:", data.error);
        setMsg(data.error);
        setShowToastError(true);
        setTimeout(() => {
          setShowToastError(false);
        }, 5000);
        setOpenModal(false);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error);
      setOpenModal(false);
    }
  };

  const getColaboradores = () => {
    // Validar que empresas tenga datos
    if (!empresas || !empresas[0] || !empresas[0].id_empresa) {
      console.warn("No hay datos de empresa para cargar colaboradores");
      return;
    }

    fetch(
      `${API_URL}getColaboradores.php?idEmpresa=${empresas[0].id_empresa}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      },
    )
      .then((response) => {
        if (!response.ok) {
          throw new Error(`Error HTTP: ${response.status}`);
        }
        return response.text();
      })
      .then((text) => {
        const startIndex = text.indexOf("[{");
        const endIndex = text.lastIndexOf("}]") + 2;
        let jsonResponse = text;

        if (startIndex !== -1 && endIndex > startIndex) {
          jsonResponse = text.substring(startIndex, endIndex);
        }

        try {
          const responseData = JSON.parse(jsonResponse);

          if (Array.isArray(responseData)) {
            setUserData(responseData);
          } else {
            console.warn("Respuesta de colaboradores no es un array");
            setUserData([]);
          }
        } catch (error) {
          console.error("Error al analizar JSON de colaboradores:", error);
          setUserData([]);
        }
      })
      .catch((error) => {
        console.error("Error al obtener colaboradores:", error);
        setUserData([]);
      });
  };

  const handleFilesChange = (e) => {
    const { name, files } = e.target;
    setFormDataPerson({ ...formDataPerson, [name]: files[0] }); // Assuming only single file selection
  };
  const handleSubmitPerson = async (e) => {
    e.preventDefault();
    setIsOpenSpinner(true);
    setFormDataPerson((prevState) => ({
      ...prevState,
      idEmpresa: empresas[0].id_empresa,
      empresa: empresas[0].nombre,
    }));
    const formDataToSend = new FormData();
    formDataToSend.append("idEmpresa", formDataPerson.idEmpresa);
    formDataToSend.append("imagen", formDataPerson.imagen);
    formDataToSend.append("nombre", formDataPerson.nombre);
    formDataToSend.append("apellidoMaterno", formDataPerson.apellidoMaterno);
    formDataToSend.append("apellidoPaterno", formDataPerson.apellidoPaterno);
    formDataToSend.append("email", formDataPerson.email);
    formDataToSend.append("cargo", formDataPerson.cargo);
    formDataToSend.append("numero", formDataPerson.numero);
    formDataToSend.append("empresa", formDataPerson.empresa);

    try {
      const response = await fetch(`${API_URL}insertColaborador.php`, {
        method: "POST",
        body: formDataToSend,
      });
      if (response.ok) {
        setIsOpenSpinner(false);
        setShowToast(true);

        setTimeout(() => {
          setShowToast(false);
        }, 5000);
        setFormDataPerson({
          idEmpresa: null,
          imagen: null, // Changed to null to hold the file object
          nombre: null,
          apellidoMaterno: null,
          apellidoPaterno: null,
          email: null,
          cargo: null,
          numero: null,
          empresa: null,
        });
        setOpenModalPerson(false);
        // Handle success
      } else {
        // Handle error
        console.error("Error al registrar el newsletter:");
        setMsg("error");
        setIsOpenSpinner(false);
        setShowToastError(true);
        setTimeout(() => {
          setShowToastError(false);
        }, 5000);
        setOpenModalPerson(false);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error.message);

      setMsg(`Error: ${error.message}`);
      setIsOpenSpinner(false);
      setShowToastError(true);
      setTimeout(() => {
        setShowToastError(false);
      }, 5000);
      setOpenModalPerson(false);
    }
  };

  const handleUpdatePerson = async (e) => {
    e.preventDefault();
    setIsOpenSpinner(true);
    setFormDataPerson((prevState) => ({
      ...prevState,
      idEmpresa: empresas[0].id_empresa,
      empresa: empresas[0].nombre,
    }));
    const formDataToSend = new FormData();
    formDataToSend.append("idEmpresa", formDataPerson.idEmpresa);
    formDataToSend.append("imagen", formDataPerson.imagen);
    formDataToSend.append("nombre", formDataPerson.nombre);
    formDataToSend.append("apellidoMaterno", formDataPerson.apellidoMaterno);
    formDataToSend.append("apellidoPaterno", formDataPerson.apellidoPaterno);
    formDataToSend.append("email", formDataPerson.email);
    formDataToSend.append("cargo", formDataPerson.cargo);
    formDataToSend.append("numero", formDataPerson.numero);
    formDataToSend.append("empresa", formDataPerson.empresa);

    try {
      const response = await fetch(`${API_URL}updateColaborador.php`, {
        method: "POST",
        body: formDataToSend,
      });
      if (response.ok) {
        setIsOpenSpinner(false);
        setShowToast(true);

        setTimeout(() => {
          setShowToast(false);
        }, 5000);
        setFormDataPerson({
          idEmpresa: null,
          imagen: null, // Changed to null to hold the file object
          nombre: null,
          apellidoMaterno: null,
          apellidoPaterno: null,
          email: null,
          cargo: null,
          numero: null,
          empresa: null,
        });
        setOpenModalPerson(false);
        // Handle success
      } else {
        // Handle error
        console.error("Error al registrar el newsletter:");
        setMsg("error");
        setIsOpenSpinner(false);
        setShowToastError(true);
        setTimeout(() => {
          setShowToastError(false);
        }, 5000);
        setOpenModalPerson(false);
      }
    } catch (error) {
      console.error("Error en la solicitud:", error.message);

      setMsg(`Error: ${error.message}`);
      setIsOpenSpinner(false);
      setShowToastError(true);
      setTimeout(() => {
        setShowToastError(false);
      }, 5000);
      setOpenModalPerson(false);
    }
  };
  const handleFileChange = (e) => {
    // Handling input changes for file inputs
    const { name, files } = e.target;
    setFormData({ ...formData, [name]: files[0] }); // Assuming only single file selection
  };

  const handleSave = () => {
    const inputElement = document.querySelector(".busqueda-input");
    const key = inputElement.getAttribute("key");

    setId(key);

    // Actualiza el estado con los nuevos productos

    setSearchTerm("");
    setSave(false);
  };

  return (
    <section className="fixed overflow-auto bg-gray-100  top-10 left-0 bottom-0 right-0">
      {" "}
      <Spinner isOpen={IsOpenSpinner}></Spinner>{" "}
      {showToast && (
        <Toast isOpen={true} title="Éxito" text="Agregado con exito" />
      )}{" "}
      {showToastError && <ToastError isOpen={true} title="Error" text={msg} />}{" "}
      {openModal && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="fixed inset-0 bg-black/50"
            onClick={() => {
              setOpenModal(false);
              setFormData({ id_empresa_fk: null, imagen_url: null });
            }}
          />
          <div className="relative z-10 bg-white rounded-lg shadow-xl w-full max-w-lg mx-4">
            <div className="flex items-center justify-between p-4 border-b fondo-rojo text-white rounded-t-lg">
              <h3 className="text-lg font-semibold">
                <i className="bx bx-cloud-upload"></i>&nbsp;Carga tus recursos
                corporativos
              </h3>
              <button
                onClick={() => {
                  setOpenModal(false);
                  setFormData({ id_empresa_fk: null, imagen_url: null });
                }}
                className="text-white hover:text-gray-200 text-2xl leading-none"
              >
                &times;
              </button>
            </div>
            <div className="p-4">
              <p className="text-sm mb-2">
                Puedes cargar aqui tus images ó presentación (Máximo 5 archivos)
              </p>
              <input
                onChange={handleFileChange}
                name="imagen_url"
                id="file-upload"
                accept="application/pdf, image/png, image/jpeg, image/jpg"
                type="file"
              />
              <button
                onClick={formData.imagen_url != null ? handleSubmit : null}
                className={`w-full bg-blue-600 my-2 h-10 justify-center cursor-pointer items-center flex ${
                  formData.imagen_url != null ? "opacity-100" : "opacity-40"
                } rounded-md text-white`}
              >
                <i className="bx bx-save"></i>&nbsp;Cargar
              </button>
            </div>
          </div>
        </div>
      )}
      {openModalPerson && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div
            className="fixed inset-0 bg-black/50"
            onClick={() => {
              setOpenModalPerson(false);
              setPerson("");
            }}
          />
          <div className="relative z-10 bg-white rounded-lg shadow-xl w-full max-w-lg mx-4 max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between p-4 border-b fondo-rojo text-white rounded-t-lg">
              <h3 className="text-lg font-semibold">
                <i className="bx bx-user"></i>&nbsp;Enrrola a tus colaboradores
              </h3>
              <button
                onClick={() => {
                  setOpenModalPerson(false);
                  setPerson("");
                }}
                className="text-white hover:text-gray-200 text-2xl leading-none"
              >
                &times;
              </button>
            </div>
            <div className="p-4">
              <div className=" w-full ">
                <div className="flex">
                  <div className="w-full mr-2">
                    <label
                      htmlFor="nombre"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    >
                      Nombre
                    </label>
                    <input
                      id="nombre"
                      value={formDataPerson.nombre}
                      onChange={handleChangePerson}
                      name="nombre"
                      placeholder="Agrega tu nombre"
                      type="text"
                      className="w-full border-gray-300 border rounded-md mb-1"
                    />
                  </div>
                  <div className="w-full">
                    <label
                      htmlFor="foto"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    >
                      Foto
                    </label>
                    <input
                      onChange={handleFilesChange}
                      id="file-upload"
                      accept="application/pdf, image/png, image/jpeg, image/jpg"
                      name="imagen"
                      placeholder="Agrega tu url de imagen"
                      type="file"
                      className="w-full border-gray-300 border rounded-md mb-1"
                    />
                  </div>
                </div>

                <div className="flex">
                  <div className="w-full mr-2">
                    <label
                      htmlFor="apellidoPaterno"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    >
                      Apellido Paterno
                    </label>
                    <input
                      value={formDataPerson.apellidoPaterno}
                      onChange={handleChangePerson}
                      placeholder="Apellido paterno"
                      name="apellidoPaterno"
                      type="text"
                      className="w-full border-gray-300 border rounded-md mb-1"
                    />
                  </div>
                  <div className="w-full">
                    <label
                      htmlFor="apellidoMaterno"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    >
                      Apellido Materno
                    </label>
                    <input
                      value={formDataPerson.apellidoMaterno}
                      onChange={handleChangePerson}
                      placeholder="Apellido materno"
                      name="apellidoMaterno"
                      type="text"
                      className="w-full border-gray-300 border rounded-md mb-1"
                    />
                  </div>
                </div>
                <div className="flex">
                  <div className="w-full mr-2">
                    <label
                      htmlFor="email"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    >
                      Email
                    </label>

                    <input
                      value={formDataPerson.email}
                      onChange={handleChangePerson}
                      placeholder="Email"
                      name="email"
                      type="text"
                      className="w-full border-gray-300 border rounded-md mb-1"
                    />
                  </div>
                  <div className="w-full">
                    <label
                      htmlFor="numero"
                      className="block text-sm font-medium leading-6 text-gray-900"
                    >
                      N&uacute;mero
                    </label>

                    <input
                      value={formDataPerson.numero}
                      onChange={handleChangePerson}
                      placeholder="Celular"
                      name="numero"
                      type="text"
                      className="w-full border-gray-300 border rounded-md mb-1"
                    />
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="cargo"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Cargo
                  </label>

                  <input
                    value={formDataPerson.cargo}
                    onChange={handleChangePerson}
                    placeholder="Cargo"
                    name="cargo"
                    type="text"
                    className="w-full border-gray-300 border rounded-md mb-1"
                  />
                </div>
                <div>
                  <label
                    htmlFor="Empresa"
                    className="block text-sm font-medium leading-6 text-gray-900"
                  >
                    Empresa
                  </label>

                  <input
                    value={empresas[0].nombre}
                    placeholder="Empresa"
                    type="text"
                    name="empresa"
                    readOnly
                    className="w-full border-gray-300 border rounded-md mb-1"
                  />
                </div>
                {formDataPerson.estatus === 1 ? (
                  <button
                    onClick={
                      Object.keys(formDataPerson).every(
                        (key) =>
                          key === "idEmpresa" ||
                          key === "imagen" ||
                          key === "empresa" ||
                          (formDataPerson[key] !== "" &&
                            formDataPerson[key] !== null),
                      )
                        ? handleUpdatePerson
                        : null
                    }
                    className={`w-full bg-blue-600 my-2 h-10 justify-center cursor-pointer items-center flex ${
                      Object.keys(formDataPerson).every(
                        (key) =>
                          key === "idEmpresa" ||
                          key === "empresa" ||
                          key === "imagen" ||
                          (formDataPerson[key] !== "" &&
                            formDataPerson[key] !== null),
                      )
                        ? "opacity-100"
                        : "opacity-40"
                    } rounded-md text-white`}
                  >
                    <i class="bx bx-save"></i>&nbsp;Actualizar
                  </button>
                ) : (
                  <button
                    onClick={
                      Object.keys(formDataPerson).every(
                        (key) =>
                          key === "idEmpresa" ||
                          key === "empresa" ||
                          (formDataPerson[key] !== "" &&
                            formDataPerson[key] !== null),
                      )
                        ? handleSubmitPerson
                        : null
                    }
                    className={`w-full bg-blue-600 my-2 h-10 justify-center cursor-pointer items-center flex ${
                      Object.keys(formDataPerson).every(
                        (key) =>
                          key === "idEmpresa" ||
                          key === "empresa" ||
                          (formDataPerson[key] !== "" &&
                            formDataPerson[key] !== null),
                      )
                        ? "opacity-100"
                        : "opacity-40"
                    } rounded-md text-white`}
                  >
                    <i class="bx bx-save"></i>&nbsp;Enviar
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
      {empresas && empresas.length > 0 ? (
        <div className="pb-10 ">
          <div className="md:p-4 p-1 md:mt-12 mt-10 relative">
            <div className="w-full h-[40vh] rounded-2xl overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100 shadow-lg">
              <img
                className="w-full h-full object-contain"
                src={`${API_URL}${empresas[0]?.portada}`}
                alt="Portada"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.parentNode.classList.add(
                    "flex",
                    "items-center",
                    "justify-center",
                  );
                  e.target.parentNode.innerHTML =
                    '<div class="text-gray-400 text-center"><i class="bx bx-image text-6xl"></i><p class="mt-2">Sin imagen de portada</p></div>';
                }}
              />
            </div>
            <div className="absolute bottom-[-30px] bg-white rounded-2xl shadow-xl left-10 border-4 border-white">
              <img
                className="w-24 h-24 rounded-xl object-contain p-2"
                src={`${API_URL}${empresas[0]?.logo}`}
                alt="Logo"
                onError={(e) => {
                  e.target.style.display = "none";
                  e.target.parentNode.innerHTML = `<div class="w-24 h-24 rounded-xl bg-gradient-to-br from-blue-500 to-indigo-600 flex items-center justify-center text-white font-bold text-2xl">${
                    empresas[0]?.nombre?.charAt(0) || "E"
                  }</div>`;
                }}
              />
            </div>
          </div>
          <div className="flex justify-between flex-wrap text-left mt-16 mb-4 xl:mb-1 mx-2 ">
            <div className=" w-full flex flex-wrap justify-between p-2">
              <h3
                style={{ color: empresas[0].colorHex }}
                className={`text-[${empresas[0].colorHex}]  font-bold  text-2xl`}
              >
                {empresas[0].nombre}
              </h3>
              <p className="flex items-center text-sm text-gray-500">
                <i class="bx text-2xl bx-current-location mr-2"></i>
                {empresas[0].direccion}
              </p>
            </div>
          </div>
          <div className="block md:flex items-center md:justify-between bg-white rounded-xl shadow-md border border-gray-200 mx-2 overflow-hidden">
            <div className="md:w-3/4 w-full mt-2 md:mt-0 flex flex-wrap items-center md:justify-start justify-center bg-gray-50">
              <div
                style={{
                  backgroundColor:
                    active === "aboutus" ? empresas[0].colorHex : "transparent",
                  color: active === "aboutus" ? "white" : "#6B7280",
                }}
                onClick={() => setActive("aboutus")}
                className={`font-semibold h-full md:px-6 px-4 py-4 mx-1 cursor-pointer text-sm transition-all duration-300 hover:bg-gray-100 ${
                  active === "aboutus" ? "shadow-md" : ""
                }`}
              >
                <i className="bx bx-info-circle mr-2"></i>
                Nosotros
              </div>
              <div
                style={{
                  backgroundColor:
                    active === "contact" ? empresas[0].colorHex : "transparent",
                  color: active === "contact" ? "white" : "#6B7280",
                }}
                onClick={() => {
                  setActive("contact");
                  getColaboradores();
                }}
                className={`font-semibold h-full md:px-6 px-4 py-4 mx-1 cursor-pointer text-sm transition-all duration-300 hover:bg-gray-100 ${
                  active === "contact" ? "shadow-md" : ""
                }`}
              >
                <i className="bx bx-phone mr-2"></i>
                Contacto
              </div>
              <div
                style={{
                  backgroundColor:
                    active === "objectsAtachments"
                      ? empresas[0].colorHex
                      : "transparent",
                  color: active === "objectsAtachments" ? "white" : "#6B7280",
                }}
                onClick={() => {
                  setActive("objectsAtachments");
                  getImagenEmpresa();
                }}
                className={`font-semibold h-full md:px-6 px-4 py-4 mx-1 cursor-pointer text-sm transition-all duration-300 hover:bg-gray-100 ${
                  active === "objectsAtachments" ? "shadow-md" : ""
                }`}
              >
                <i className="bx bx-folder mr-2"></i>
                Documentación
              </div>
              <div
                style={{
                  backgroundColor:
                    active === "reviews" ? empresas[0].colorHex : "transparent",
                  color: active === "reviews" ? "white" : "#6B7280",
                }}
                onClick={() => {
                  setActive("reviews");
                  getReviewsEmpresa();
                }}
                className={`font-semibold h-full md:px-6 px-4 py-4 mx-1 cursor-pointer text-sm transition-all duration-300 hover:bg-gray-100 ${
                  active === "reviews" ? "shadow-md" : ""
                }`}
              >
                <i className="bx bx-star mr-2"></i>
                Reviews
              </div>
            </div>

            <div className="flex justify-end gap-2 m-2 p-3 md:m-0">
              <a
                target="_blank"
                href={empresas[0].whatsapp}
                style={{ background: empresas[0].colorHex }}
                className="flex items-center justify-center text-white w-11 h-11 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-105"
                rel="noreferrer"
              >
                <i class="bx bxl-whatsapp text-2xl"></i>
              </a>
              <a
                target="_blank"
                href={empresas[0].linkedin ?? ""}
                style={{ background: empresas[0].colorHex }}
                className="flex items-center justify-center text-white w-11 h-11 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-105"
                rel="noreferrer"
              >
                <i class="bx bxl-linkedin text-2xl"></i>
              </a>
              <a
                target="_blank"
                href={empresas[0].instagram}
                style={{ background: empresas[0].colorHex }}
                className="flex items-center justify-center text-white w-11 h-11 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-105"
                rel="noreferrer"
              >
                <i class="bx bxl-instagram text-2xl"></i>
              </a>
              <a
                target="_blank"
                href={empresas[0].facebook}
                style={{ background: empresas[0].colorHex }}
                className="flex items-center justify-center text-white w-11 h-11 rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 hover:scale-105"
                rel="noreferrer"
              >
                <i class="bx bxl-facebook text-2xl"></i>
              </a>
            </div>
          </div>
          <div className="text-sm p-2 ">
            {active === "aboutus" && (
              <div className="space-y-6 mt-4">
                <div className="bg-gradient-to-br from-white to-gray-50 border border-gray-200 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <div className="flex items-center gap-3 mb-6">
                    <div
                      style={{ background: empresas[0].colorHex }}
                      className="w-12 h-12 rounded-xl flex items-center justify-center shadow-md"
                    >
                      <i className="bx bx-target-lock text-2xl text-white"></i>
                    </div>
                    <h3
                      style={{ color: empresas[0].colorHex }}
                      className="text-2xl font-bold"
                    >
                      Misión
                    </h3>
                  </div>
                  <div
                    className="bg-white rounded-xl p-6 border-l-4"
                    style={{ borderLeftColor: empresas[0].colorHex }}
                  >
                    <p className="text-gray-700 text-base leading-relaxed italic">
                      "{empresas[0].mision}"
                    </p>
                  </div>
                </div>
                <div className="bg-gradient-to-br from-white to-gray-50 border border-gray-200 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-shadow duration-300">
                  <div className="flex items-center gap-3 mb-6">
                    <div
                      style={{ background: empresas[0].colorHex }}
                      className="w-12 h-12 rounded-xl flex items-center justify-center shadow-md"
                    >
                      <i className="bx bx-low-vision text-2xl text-white"></i>
                    </div>
                    <h3
                      style={{ color: empresas[0].colorHex }}
                      className="text-2xl font-bold"
                    >
                      Visión
                    </h3>
                  </div>
                  <div
                    className="bg-white rounded-xl p-6 border-l-4"
                    style={{ borderLeftColor: empresas[0].colorHex }}
                  >
                    <p className="text-gray-700 text-base leading-relaxed italic">
                      "{empresas[0].vision}"
                    </p>
                  </div>
                </div>
              </div>
            )}
            {active === "contact" && (
              <>
                <div className="w-full xl:flex xl:flex-row xl:items-stretch gap-4">
                  <div className="text-left xl:w-2/3 w-full bg-white border border-gray-200 mt-4 rounded-2xl shadow-lg md:p-6 p-4">
                    <div className="md:flex block justify-evenly w-full pb-4 mb-4 border-b border-gray-100">
                      <div className="text-left md:w-1/2 w-full mb-4 md:mb-0 bg-gray-50 rounded-xl p-4">
                        <div className="flex items-center gap-2 mb-2">
                          <i
                            className="bx bx-phone text-xl"
                            style={{ color: empresas[0].colorHex }}
                          ></i>
                          <h5
                            style={{ color: empresas[0].colorHex }}
                            className="font-semibold text-sm"
                          >
                            Número de teléfono
                          </h5>
                        </div>
                        <h5 className="text-gray-700 font-medium pl-7">
                          {empresas[0].telefono}
                        </h5>
                      </div>
                      <div className="text-left md:w-1/2 w-full md:ml-4 bg-gray-50 rounded-xl p-4">
                        <div className="flex items-center gap-2 mb-2">
                          <i
                            className="bx bx-envelope text-xl"
                            style={{ color: empresas[0].colorHex }}
                          ></i>
                          <h5
                            style={{ color: empresas[0].colorHex }}
                            className="font-semibold text-sm"
                          >
                            Email
                          </h5>
                        </div>
                        <h5 className="text-gray-700 font-medium pl-7 break-all">
                          {empresas[0].email}
                        </h5>
                      </div>
                    </div>
                    <div className="md:flex block justify-evenly w-full pb-4 mb-4 border-b border-gray-100">
                      <div className="text-left md:w-1/2 w-full mb-4 md:mb-0 bg-gray-50 rounded-xl p-4">
                        <div className="flex items-center gap-2 mb-2">
                          <i
                            className="bx bx-user text-xl"
                            style={{ color: empresas[0].colorHex }}
                          ></i>
                          <h5
                            style={{ color: empresas[0].colorHex }}
                            className="font-semibold text-sm"
                          >
                            Encargado
                          </h5>
                        </div>
                        <h5 className="text-gray-700 font-medium pl-7">
                          {empresas[0].especialidad}
                        </h5>
                      </div>
                      <div className="text-left md:w-1/2 w-full md:ml-4 bg-gray-50 rounded-xl p-4">
                        <div className="flex items-center gap-2 mb-2">
                          <i
                            className="bx bx-globe text-xl"
                            style={{ color: empresas[0].colorHex }}
                          ></i>
                          <h5
                            style={{ color: empresas[0].colorHex }}
                            className="font-semibold text-sm"
                          >
                            Sitio web
                          </h5>
                        </div>
                        <h5 className="text-gray-700 font-medium pl-7 break-all">
                          <a
                            target="_blank"
                            href={empresas[0].sitioWeb}
                            className="hover:underline"
                            style={{ color: empresas[0].colorHex }}
                            rel="noreferrer"
                          >
                            {empresas[0].sitioWeb}
                          </a>
                        </h5>
                      </div>
                    </div>
                    <div className="md:flex block justify-evenly w-full pb-4 mb-4 border-b border-gray-100">
                      <div className="text-left md:w-1/2 w-full mb-4 md:mb-0 bg-gray-50 rounded-xl p-4">
                        <div className="flex items-center gap-2 mb-2">
                          <i
                            className="bx bx-briefcase text-xl"
                            style={{ color: empresas[0].colorHex }}
                          ></i>
                          <h5
                            style={{ color: empresas[0].colorHex }}
                            className="font-semibold text-sm"
                          >
                            Giro
                          </h5>
                        </div>
                        <h5 className="text-gray-700 font-medium pl-7">
                          {empresas[0].giro}
                        </h5>
                      </div>
                      <div className="text-left md:w-1/2 w-full md:ml-4 bg-gray-50 rounded-xl p-4">
                        <div className="flex items-center gap-2 mb-2">
                          <i
                            className="bx bx-buildings text-xl"
                            style={{ color: empresas[0].colorHex }}
                          ></i>
                          <h5
                            style={{ color: empresas[0].colorHex }}
                            className="font-semibold text-sm"
                          >
                            Sede
                          </h5>
                        </div>
                        <h5 className="text-gray-700 font-medium pl-7">
                          {empresas[0].sede}
                        </h5>
                      </div>
                    </div>
                    <div className="md:flex block justify-evenly w-full border-b border-gray-200">
                      <div className="relative w-full my-10">
                        {/* Botón izquierdo */}
                        {showLeft && (
                          <button
                            onClick={() => {
                              const container = scrollRef.current;
                              if (!container) return;

                              container.scrollBy({
                                left: -300,
                                behavior: "smooth",
                              });
                              setTimeout(handleScrollCheck, 400);
                            }}
                            className="absolute z-10 left-0 top-1/2 transform -translate-y-1/2 bg-white shadow-md border rounded-full w-10 h-10 flex items-center justify-center"
                          >
                            <i className="bx bx-chevron-left text-2xl text-gray-700"></i>
                          </button>
                        )}

                        {/* Contenedor scrollable */}
                        <div
                          ref={scrollRef}
                          className="overflow-x-auto flex gap-4 px-6 py-4 snap-x snap-mandatory scroll-smooth"
                        >
                          {/* Botón para agregar nuevo socio */}
                          {isOwner && (
                            <div
                              onClick={() => {
                                setOpenModalPerson(true);
                                setFormDataPerson({
                                  idEmpresa: empresas[0].id_empresa,
                                  empresa: "",
                                  nombre: "",
                                  apellidoMaterno: "",
                                  apellidoPaterno: "",
                                  email: "",
                                  cargo: "",
                                  numero: "",
                                  imagen: "",
                                  estatus: 0,
                                });
                              }}
                              className="snap-start flex-shrink-0 w-[260px] bg-gray-100 border border-dashed border-gray-400 rounded-xl shadow-inner flex flex-col items-center justify-center px-4 py-6 cursor-pointer hover:bg-gray-200"
                            >
                              <i className="bx bx-plus text-4xl text-gray-600"></i>
                              <span className="text-sm font-medium text-gray-700 mt-2">
                                Añadir nuevo socio
                              </span>
                            </div>
                          )}

                          {Array.isArray(userData) && userData.length > 0 ? (
                            userData.map((user) => (
                              <div
                                key={user.id}
                                onClick={() => {
                                  setOpenModalPerson(true);
                                  setFormDataPerson({
                                    idEmpresa: empresas[0].id_empresa,
                                    empresa: empresas[0].nombre,
                                    nombre: user.nombre,
                                    apellidoMaterno: user.apellidoMaterno,
                                    apellidoPaterno: user.apellidoPaterno,
                                    email: user.email,
                                    cargo: user.cargo,
                                    numero: user.numeroTelefonico,
                                    imagen: user.urlPhoto,
                                    estatus: 1,
                                  });
                                }}
                                className="snap-start flex-shrink-0 w-[260px] bg-white border border-gray-300 rounded-xl shadow-md px-4 py-4 text-center cursor-pointer hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                              >
                                {user.urlPhoto ? (
                                  <img
                                    src={`${API_URL}${user.urlPhoto}`}
                                    alt="Avatar"
                                    className="w-24 h-24 mx-auto rounded-full object-contain bg-gray-50 ring-4 ring-gray-300 p-1"
                                    onError={(e) => {
                                      e.target.style.display = "none";
                                      const div = document.createElement("div");
                                      div.style.backgroundColor =
                                        empresas[0].colorHex;
                                      div.className =
                                        "w-24 h-24 mx-auto flex items-center justify-center rounded-full text-white font-semibold text-2xl ring-4 ring-gray-300";
                                      div.textContent =
                                        user.nombre.charAt(0) +
                                        user.apellidoPaterno.charAt(0);
                                      e.target.parentNode.insertBefore(
                                        div,
                                        e.target,
                                      );
                                    }}
                                  />
                                ) : (
                                  <div
                                    style={{
                                      backgroundColor: empresas[0].colorHex,
                                    }}
                                    className="w-24 h-24 mx-auto flex items-center justify-center rounded-full text-white font-semibold text-2xl ring-4 ring-gray-300"
                                  >
                                    {user.nombre.charAt(0)}
                                    {user.apellidoPaterno.charAt(0)}
                                  </div>
                                )}
                                <h2 className="mt-2 text-sm font-bold text-gray-700">
                                  {user.nombre} {user.apellidoPaterno}
                                </h2>
                                <p className="text-sm text-gray-500">
                                  {user.cargo}
                                </p>
                                <p className="text-sm text-gray-500">
                                  {user.numeroTelefonico}
                                </p>
                              </div>
                            ))
                          ) : (
                            <div className="snap-start flex-shrink-0 w-[260px] flex items-center justify-center text-center text-gray-500 border border-dashed border-gray-300 rounded-xl px-4">
                              No se han enrolado colaboradores.
                            </div>
                          )}
                        </div>

                        {/* Botón derecho */}
                        {showRight && (
                          <button
                            onClick={() => {
                              const container = scrollRef.current;
                              if (!container) return;

                              container.scrollBy({
                                left: 300,
                                behavior: "smooth",
                              });
                              setTimeout(handleScrollCheck, 400);
                            }}
                            className="absolute z-10 right-0 top-1/2 transform -translate-y-1/2 bg-white shadow-md border rounded-full w-10 h-10 flex items-center justify-center"
                          >
                            <i className="bx bx-chevron-right text-2xl text-gray-700"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="xl:w-1/3 w-full border border-gray-200 rounded-2xl mt-4 overflow-hidden shadow-lg">
                    <div className="h-full min-h-[500px] flex flex-col">
                      <div className="bg-gradient-to-r from-gray-50 to-gray-100 px-4 py-3 border-b border-gray-200">
                        <div className="flex items-center gap-2">
                          <i
                            className="bx bx-map text-xl"
                            style={{ color: empresas[0].colorHex }}
                          ></i>
                          <h4 className="font-semibold text-gray-800">
                            Ubicación
                          </h4>
                        </div>
                      </div>
                      <iframe
                        className="w-full flex-1 min-h-[450px]"
                        title="Google Maps"
                        loading="lazy"
                        allowFullScreen
                        src={empresas[0].googleUrl}
                      ></iframe>
                    </div>
                  </div>
                </div>
              </>
            )}
            {active === "objectsAtachments" && (
              <div className="text-left flex flex-wrap bg-white border border-gray-300 mt-1 rounded-md p-5 gap-4">
                {Array.isArray(image) && image.length > 0 ? (
                  <div className="text-left flex flex-wrap rounded-md gap-4 w-full">
                    {image.map((item) => (
                      <div className="relative group" key={item.id}>
                        <div className="w-64 h-64 bg-gray-50 border border-gray-300 shadow-lg rounded-xl overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-1">
                          <img
                            className="w-full h-full object-contain p-2"
                            src={`${API_URL}/detalles/image/${item.imagen_url}`}
                            alt={`imagen-${item.id}`}
                            onError={(e) => {
                              e.target.style.display = "none";
                              e.target.parentNode.innerHTML =
                                '<div class="w-full h-full flex items-center justify-center text-gray-400"><i class="bx bx-image text-6xl"></i></div>';
                            }}
                          />
                        </div>
                        {isOwner && (
                          <button
                            onClick={() => deleteImageDetail(item.id)}
                            className="absolute bg-red-500 hover:bg-red-600 h-8 w-8 flex items-center rounded-full justify-center right-2 top-2 text-white shadow-md opacity-0 group-hover:opacity-100 transition-opacity"
                          >
                            <i className="bx bx-trash text-lg"></i>
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className="text-left bg-white border border-gray-300 mt-4 rounded-md p-5">
                    No hay imágenes
                  </div>
                )}

                {isOwner && (
                  <div className="w-64 h-64 flex items-center justify-center">
                    <button
                      onClick={() => {
                        openModals();
                      }}
                      className="w-full h-full bg-gradient-to-br from-blue-50 to-indigo-50 hover:from-blue-100 hover:to-indigo-100 flex flex-col items-center justify-center text-blue-600 border-2 border-dashed border-blue-300 rounded-xl transition-all duration-300 hover:border-blue-500 hover:shadow-lg"
                    >
                      <i class="bx bx-cloud-upload text-5xl mb-2"></i>
                      <span className="text-sm font-medium">Subir imagen</span>
                    </button>
                  </div>
                )}
              </div>
            )}
            {active === "reviews" && (
              <div class="xl:max-w-[70%] md:max-w-2xl xs:max-w-full max-w-xl mx-auto mt-4">
                <div
                  className="bg-white rounded-2xl shadow-lg border border-gray-200 p-6 mb-6"
                  onSubmit={insertReview}
                >
                  <div className="flex items-center gap-3 mb-6">
                    <div
                      style={{ background: empresas[0].colorHex }}
                      className="w-12 h-12 rounded-xl flex items-center justify-center shadow-md"
                    >
                      <i className="bx bx-message-square-edit text-2xl text-white"></i>
                    </div>
                    <h3
                      style={{ color: empresas[0].colorHex }}
                      className="text-xl font-bold"
                    >
                      Escribe tu reseña
                    </h3>
                  </div>
                  <form>
                    <div class="mb-4">
                      <div class="bg-gray-50 rounded-xl p-4">
                        <div class="flex flex-wrap">
                          <div className="w-full">
                            <div className="mb-4">
                              <label
                                htmlFor="descripcion"
                                className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-3"
                              >
                                <i className="bx bx-comment-detail"></i>
                                Tu opinión nos importa
                              </label>

                              <textarea
                                name="descripcion"
                                value={review.descripcion ?? ""}
                                onChange={handleChange}
                                defaultValue=" "
                                maxLength={500}
                                rows={5}
                                placeholder="Comparte tu experiencia con esta empresa..."
                                className="w-full border-2 border-gray-200 focus:border-blue-500 rounded-xl py-3 px-4 text-gray-700 text-base resize-none transition-colors duration-200 bg-white"
                                required
                              ></textarea>
                              <div className="flex justify-between items-center mt-3">
                                <span className="text-xs text-gray-500">
                                  {review.descripcion?.length || 0}/500
                                  caracteres
                                </span>
                                <button
                                  type="submit"
                                  style={{ background: empresas[0].colorHex }}
                                  class="flex items-center gap-2 px-6 py-3 hover:opacity-90 font-semibold text-sm text-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5"
                                >
                                  <i className="bx bx-send"></i>
                                  Publicar Reseña
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                {Array.isArray(comentarios) &&
                typeof comentarios !== "undefined" &&
                comentarios !== null &&
                comentarios !== "" &&
                comentarios.length !== 0 &&
                comentarios.length > 0 ? (
                  <div className="space-y-4">
                    {typeof comentarios !== "undefined" &&
                      comentarios !== null &&
                      comentarios !== "" &&
                      comentarios.length !== 0 &&
                      comentarios.map((item) => (
                        <div class="w-full">
                          <div class="bg-white border border-gray-200 rounded-2xl shadow-md hover:shadow-lg transition-shadow duration-300 overflow-hidden">
                            <div class="px-6 py-4 bg-gradient-to-r from-gray-50 to-white border-b border-gray-100">
                              <div class="flex flex-wrap items-center justify-between">
                                <div className="flex items-center gap-3">
                                  <div
                                    style={{ background: empresas[0].colorHex }}
                                    className="w-10 h-10 rounded-full flex items-center justify-center text-white font-bold shadow-md"
                                  >
                                    {item.autor?.charAt(0) || "U"}
                                  </div>
                                  <div>
                                    <h4 class="text-base font-bold text-gray-800">
                                      {item.autor}
                                    </h4>
                                    <p class="text-xs text-gray-500">
                                      {item.fechaRegistro}
                                    </p>
                                  </div>
                                </div>
                                <div class="flex gap-1 mt-2 md:mt-0">
                                  {[...Array(5)].map((_, i) => (
                                    <svg
                                      key={i}
                                      width="18"
                                      height="18"
                                      viewBox="0 0 20 20"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M20 7.91677H12.4167L10 0.416763L7.58333 7.91677H0L6.18335 12.3168L3.81668 19.5834L10 15.0834L16.1834 19.5834L13.8167 12.3168L20 7.91677Z"
                                        fill="#FFCB00"
                                      ></path>
                                    </svg>
                                  ))}
                                </div>
                              </div>
                            </div>
                            <div class="px-6 py-5 bg-white">
                              <p class="text-gray-700 leading-relaxed text-base">
                                {item.descripcion}
                              </p>
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                ) : (
                  <div className="bg-white border border-gray-200 rounded-2xl shadow-md p-12 text-center">
                    <div className="w-20 h-20 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
                      <i className="bx bx-message-square-x text-4xl text-gray-400"></i>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-800 mb-2">
                      Sin reseñas aún
                    </h3>
                    <p className="text-gray-500 text-sm">
                      Sé el primero en compartir tu experiencia con esta empresa
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      ) : (
        <div>Cargando...</div>
      )}
    </section>
  );
}
export default DetailPage;
